import { connectGooglePayButton } from './connectGooglePayButton';
import { GooglePayButton as GooglePayButtonComponent } from './GooglePayButton';

export const GooglePayButton = connectGooglePayButton(GooglePayButtonComponent);
